/*
 * Copyright (c) 2022. Nedaware SL
 */

import {Component, Inject} from '@angular/core';
import {EditionListDialogComponent} from "./edition-list-dialog.component";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {BaseDialogData} from "../../basic-entity-front/basic-entity-table/base-dialog-data";
import {UntypedFormBuilder} from "@angular/forms";
import {EntityNameService} from "../../basic-entity-back/services/entity-name.service";
import {InterfaceProviderService} from "../../basic-entity-back/services/interface-provider.service";
import {SimpleDialogService} from "../../basic-entity-front/dialog-shell/simple-dialog.service";
import {ErrorDisplayService} from "../../basic-entity-front/services/error-display.service";
import {Usuario} from "../../model/personas/usuario.model";
import {ApiModuleFactory} from "../../api/api-module-factory.service";

@Component({
    selector: 'app-user-group-edition',
    templateUrl: './edition-list-dialog.component.html',
    styleUrls: ['./edition-list-dialog.component.scss']
})
export class UserGroupEditionComponent extends EditionListDialogComponent<any> {
    constructor(
        @Inject(MAT_DIALOG_DATA) data: BaseDialogData<any>,
        dialogRef: MatDialogRef<UserGroupEditionComponent>,
        apiService: ApiModuleFactory,
        fb: UntypedFormBuilder,
        nameProvider: EntityNameService,
        confirmationDialog: SimpleDialogService,
        interfaceProvider: InterfaceProviderService,
        errorDisplay: ErrorDisplayService
    ) {
        super(
            'grupos de usuarios',
            [{name: 'Usuarios', property: 'groups', model: Usuario}],
            data, dialogRef, apiService, fb, nameProvider, confirmationDialog, interfaceProvider, errorDisplay);
    }
}
